import React from 'react';
import { useIsMobile } from '../hooks/useDeviceType';
import ClientDashboard from './portal/ClientDashboard';
import MobileClientDashboard from './portal/MobileClientDashboard';
import StaffDashboard from './staff/StaffDashboard';
import MobileStaffDashboard from './staff/MobileStaffDashboard';

/**
 * Responsive Client Dashboard - renders appropriate dashboard based on device type
 */
export const ResponsiveClientDashboard = (props) => {
  const isMobile = useIsMobile();
  
  console.log('🔍 ResponsiveClientDashboard - isMobile:', isMobile, 'window.innerWidth:', window.innerWidth);
  
  if (isMobile) {
    console.log('✅ Rendering MobileClientDashboard');
    return <MobileClientDashboard {...props} />;
  }
  
  console.log('✅ Rendering Desktop ClientDashboard');
  return <ClientDashboard {...props} />;
};

/**
 * Responsive Staff Dashboard - renders appropriate dashboard based on device type
 */
export const ResponsiveStaffDashboard = (props) => {
  const isMobile = useIsMobile();
  
  if (isMobile) {
    return <MobileStaffDashboard {...props} />;
  }
  
  return <StaffDashboard {...props} />;
};

export default {
  ResponsiveClientDashboard,
  ResponsiveStaffDashboard
};
